import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import Keycloak from 'keycloak-js';

const isAccessAllowed = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    authData: AuthGuardData
): Promise<boolean | UrlTree> => {

    const keycloak = inject(Keycloak);
    const {authenticated} = authData;

    if (!authenticated && !window.location.origin.includes('localhost')) {
        await keycloak.login();
    }

    return true;
};

export const authGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);
